import {
  Grid,
  Tooltip,
  Badge,
  Button,
  Paper,
  TableCell,
  Collapse,
  TableRow,
  Icon,
  IconButton,
  MenuItem
} from "@material-ui/core";
import { withStyles } from "@material-ui/core/styles";
import PropTypes from "prop-types";
import React from "react";
import { translate } from "react-i18next";
import { connect } from "react-redux";
import moment from "moment";

import Loading from "../../loading";
import { styles } from "./styles";
import Snackbar from "../../snackbar";
import { _parsePhoneNumber } from "../../../partials/validateNumber";
import EditForm from "../edit";
import Autosuggest from "react-autosuggest";
import Header from "../../../partials/header";
import TableFormat from "../../../partials/TableFormat";
import FilterList from "../../../partials/filterList";
import InputFormat from "../../../partials/inputForm";
import { formatDatetime } from "../../../utils/setting";
const headCells = [
  {
    key: "isCustomer",
    numeric: false,
    disablePadding: false,
    label: "contact_is_customer"
  },
  { key: "name", numeric: false, disablePadding: false, label: "contact_name" },
  {
    key: "phone",
    numeric: false,
    disablePadding: false,
    label: "contact_phone"
  },
  {
    key: "email",
    numeric: false,
    disablePadding: false,
    label: "contact_email"
  },
  { key: "ip", numeric: false, disablePadding: false, label: "contact_ip" },
  {
    key: "createdAt",
    numeric: false,
    disablePadding: false,
    label: "contact_createdAt"
  },
  { key: "action", numeric: false, disablePadding: false, label: "action" }
];
const listIsRead = [
  {
    value: "true",
    label: "readed"
  },
  {
    value: "false",
    label: "unread"
  },
]
class Contacts extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      order: "desc",
      orderBy: "createdAt",
      selected: [],
      collapse: [],
      category: "",
      fromType: "",
      from: moment()
        .subtract(3, "months")
        .startOf("month")
        .valueOf(),
      to: moment()
        .endOf("month")
        .valueOf(),
      categoryId: "",
      suggestions: [],
      isRead: null,
      listFilter: {
        isRead: null,
        fromType: "",
        category: ""
      },
    };
  }
  componentDidMount() {
    this.props.getListCategory({ snackbar: this.snackbar });
    this.props.getListFromType({ snackbar: this.snackbar });
  }
  disabledCreateCustomer = n => {
    const { permission = {} } = this.props;
    return permission.module &&
      permission.module.customer &&
      permission.module.customer.insert
      ? n.isCustomer
      : true;
  };
  showFilter = event => {
    this.FilterList.toggleDrawer(true, event);
  };
  checkListFilter = () => {
    const { list_fromType = [], list_category = [] } = this.props;
    let { isRead, fromType, category, listFilter } = this.state;
    listFilter["isRead"] = listIsRead.find(item => item.value === isRead);
    listFilter["isRead"] = listFilter["isRead"] ? listFilter["isRead"].label : "";
    listFilter["fromType"] = list_fromType.find(item => item.value === fromType);
    listFilter["fromType"] = listFilter["fromType"] ? listFilter["fromType"].label : "";
    listFilter["category"] = list_category.find(item => item.value === category);
    listFilter["category"] = listFilter["category"] ? listFilter["category"].label : "";
    this.setState({ listFilter })
  }
  getList = async (data, applyFilter = true) => {
    this.loading.startLoading();
    const { from, to, fromType, category, categoryId, isRead } = this.state;
    let { page, rowsPerPage } = this.mTable.state;
    let filter = {};
    if (fromType) filter.fromType = fromType;
    if (category) filter.category = category;
    if (isRead !== undefined && isRead !== null) {
      if (Boolean(isRead)) filter.isRead = Boolean(isRead);
      else {
        filter.isRead = { $ne: true };
      }
    }
    if (categoryId) {
      filter.categoryId = categoryId;
      const { list_categoryId = [] } = this.props;
      if (category === "menu") {
        let find = list_categoryId.find(e => e.name === categoryId);
        if (find) filter.categoryId = find.id;
      } else if (category === "campaign") {
        let find = list_categoryId.find(e => e.title === categoryId);
        if (find) filter.categoryId = find.campaignCode;
      }
    }
    if (applyFilter)
      await this.props.getList({
        snackbar: this.snackbar,
        page: page,
        limit: rowsPerPage,
        filter: filter,
        from: from
          ? moment(from)
            .startOf("day")
            .valueOf()
          : "",
        to: to
          ? moment(to)
            .endOf("day")
            .valueOf()
          : "",
        ...data
      });
    else
      await this.props.getList({
        snackbar: this.snackbar,
        page: page,
        limit: rowsPerPage,
        ...data
      });
    this.loading.stopLoading();
    this.checkListFilter()
  };
  clearFilter = () => {
    let _this = this;
    let to = moment()
      .endOf("day")
      .valueOf();
    let from = moment()
      .subtract(3, "months")
      .startOf("day")
      .valueOf();
    this.setState(
      {
        category: "",
        fromType: "",
        from: from,
        to: to,
        categoryId: "",
        suggestions: [],
        isRead: null,
        listFilter: {
          isRead: null,
          fromType: "",
          category: ""
        },
      },
      function () {
        _this.getList();
      }
    );
  };
  snackbar = (mess, type) => {
    this.mSnackbar.handleClick(mess, type);
  };
  handleDelete = async (selected = []) => {
    let { t } = this.props;
    if (selected && selected.length) {
      let check = await this.props.delete({
        snackbar: this.snackbar,
        _id: selected,
        t: t
      });
      if (check.code === 1) {
        this.mSnackbar.handleClick(
          t("contact_listcontact_delete_successfully")
        );
        return true;
      } else {
        this.mSnackbar.handleClick(
          t("contact_listcontact_delete_unsuccessfully")
        );
        return false;
      }
    } else {
      this.mSnackbar.handleClick(t("pls_select_item"));
      return false;
    }
  };
  handleFilterDate = (from, to) => {
    const _this = this;
    this.setState(
      {
        from: from
          ? moment(from)
            .startOf("day")
            .valueOf()
          : "",
        to: to
          ? moment(to)
            .endOf("day")
            .valueOf()
          : ""
      },
      function () {
        _this.getList();
      }
    );
  };
  handleFilter = e => {
    this.setState({ [e.target.name]: e.target.value }, function () {
      // this.getList();
      if (e.target.name === "category") {
        this.setState({ categoryId: "" });
        this.getCategoryId();
      }
    });
  };
  handleCategoryId = (e, { newValue }) => {
    this.setState({ categoryId: newValue });
  };
  handleOpenCollapes = (id, contact = {}) => {
    let { collapse } = this.state;

    collapse = collapse.map((e, index) => {
      if (index !== id) return false;
      else return e;
    });
    collapse[id] = !collapse[id];
    this.setState({ collapse: collapse }, function () {
      if (contact && contact._id && !contact.isRead) {
        this.props.isRead(contact);
        this.getList();
      }
    });
  };
  getCategoryId = () => {
    const { category } = this.state;
    if (category) {
      this.props.getListCategoryId({
        snackbar: this.snackbar,
        category: category
      });
    }
  };
  getSuggestions = (value = "") => {
    const { category } = this.state;
    const { list_categoryId } = this.props;

    const inputValue = value.trim().toLowerCase();
    const inputLength = inputValue.length;

    let list =
      inputLength === 0
        ? []
        : list_categoryId.filter(e =>
          category === "menu"
            ? e.name.toLowerCase().slice(0, inputLength) === inputValue
            : category === "campaign"
              ? e.title.toLowerCase().slice(0, inputLength) === inputValue
              : e.toLowerCase().slice(0, inputLength) === inputValue
        );
    if (category === "campaign" && inputLength) {
      let temp = [];
      list_categoryId.forEach(e => {
        if (e.campaignCode.toLowerCase().slice(0, inputLength) === inputValue) {
          temp.push({
            ...e,
            title: e.campaignCode
          });
        }
      });
      list = list.concat(temp);
    }
    return list;
  };
  getSuggestionValue = suggestion => {
    const { category } = this.state;
    let value =
      category === "menu"
        ? suggestion.name
        : category === "campaign"
          ? suggestion.title
          : suggestion;
    return value;
  };
  onSuggestionsFetchRequested = ({ value }) => {
    this.setState({
      suggestions: this.getSuggestions(value)
    });
  };

  // Autosuggest will call this function every time you need to clear suggestions.
  onSuggestionsClearRequested = () => {
    this.setState({
      suggestions: []
    });
  };
  renderSuggestion = (suggestion, { query, isHighlighted }) => {
    const { category } = this.state;
    return category === "menu" ? (
      <MenuItem value={suggestion.id}>{suggestion.name}</MenuItem>
    ) : category === "campaign" ? (
      <MenuItem value={suggestion.campaignCode}>{suggestion.title}</MenuItem>
    ) : (
      <MenuItem value={suggestion}>{suggestion}</MenuItem>
    );
  };
  actionColumn = (row = {}, index) => {
    const { classes, t, list_contact = [], total } = this.props;
    return (
      <React.Fragment>
        <Button
          size="small"
          onClick={() => this.handleCreateCustomer(list_contact[index])}
          variant="outlined"
          color="primary"
          disabled
          className={classes.buttonOnRow}
        >
          {t("contact_listcontact_add")}
        </Button>
      </React.Fragment>
    );
  };
  renderCollapse = (row, index) => {
    const { classes, t, list_contact, total } = this.props;
    const { collapse = [] } = this.state;

    return (
      <TableRow style={{ height: 0 }} key={index}>
        <TableCell
          colSpan={10}
          padding={"none"}
          className={classes.tableCellInCollapes}
        >
          <Collapse in={collapse[index] ? true : false} unmountOnExit>
            <EditForm
              item={index}
              contact={list_contact[index]}
              handleClose={() => this.handleOpenCollapes(index)}
              getList={this.getList}
            />
          </Collapse>
        </TableCell>
      </TableRow>
    );
  };
  renderIsCustomer = row => {
    const { t, classes } = this.props;
    return (
      <React.Fragment>
        <Tooltip
          title={row.isCustomer ? t("contact_for_user_is_customer_of_spa") : ""}
        >
          <IconButton
            style={row.isCustomer === true ? { opacity: 1 } : { opacity: 0 }}
          >
            <Icon color="secondary">grade</Icon>
          </IconButton>
        </Tooltip>
        {!row.isRead && (
          <Badge
            className={classes.marginBadge}
            badgeContent={t("new")}
            color="secondary"
          ></Badge>
        )}
      </React.Fragment>
    );
  };
  render() {
    const {
      classes,
      t,
      list_contact = [],
      total,
      count,
      list_fromType = [],
      list_category = []
    } = this.props;
    const {
      category,
      fromType,
      from,
      to,
      categoryId,
      suggestions = [],
      isRead = null,
      collapse = [],
      listFilter
    } = this.state;
    return (
      <div>
        <Loading onRef={id => (this.loading = id)} />
        <Snackbar
          color="white"
          onRef={snackbar => (this.mSnackbar = snackbar)}
        />
        <FilterList
          onRef={id => (this.FilterList = id)}
          clearFilter={this.clearFilter}
          getList={this.getList}
        >
          {/* <Grid container spacing={3}> */}
          <Grid item xs={12} sm={12}>
            <InputFormat
              select
              label={t("status")}
              fullWidth
              value={isRead}
              onChange={this.handleFilter}
              name="isRead"
              margin="normal"
              disableUnderline={false}
            >
              <MenuItem value={null}>{t("contact_pls_select")}</MenuItem>
              {listIsRead.map((item, index) => {
                return (
                  <MenuItem
                    key={`item-is-read-${index}`}
                    value={item.value}
                  >
                    {t(item.label)}
                  </MenuItem>
                )
              })}
              {/* <MenuItem value={true}>{t("readed")}</MenuItem>
              <MenuItem value={false}>{t("unread")}</MenuItem> */}
            </InputFormat>
          </Grid>
          <Grid item xs={12} sm={12}>
            <InputFormat
              select
              label={t("contact_fromType")}
              fullWidth
              value={fromType}
              displayEmpty
              onChange={this.handleFilter}
              name="fromType"
              margin="normal"
              disableUnderline={false}
            >
              <MenuItem value="">{t("contact_pls_select")}</MenuItem>
              {list_fromType &&
                list_fromType.map(e => {
                  return (
                    <MenuItem
                      classes={{
                        root: classes.textCapitalize
                      }}
                      value={e}
                    >
                      {e}
                    </MenuItem>
                  );
                })}
            </InputFormat>
          </Grid>
          <Grid item xs={12} sm={12}>
            <InputFormat
              select
              label={t("contact_category")}
              fullWidth
              value={category}
              onChange={this.handleFilter}
              name="category"
              margin="normal"
              disableUnderline={false}
            >
              <MenuItem value="">{t("contact_pls_select")}</MenuItem>
              {list_category &&
                list_category.map(e => {
                  return (
                    <MenuItem
                      classes={{
                        root: classes.textCapitalize
                      }}
                      value={e}
                    >
                      {e}
                    </MenuItem>
                  );
                })}
            </InputFormat>
          </Grid>
          <Grid item xs={12} sm={12}>
            <Autosuggest
              renderInputComponent={inputProps => (
                <InputFormat
                  label={t("contact_categoryId")}
                  name="categoryId"
                  margin="normal"
                  required
                  value={categoryId}
                  onChange={this.handleCategoryId}
                  {...inputProps}
                />
              )}
              suggestions={suggestions}
              onSuggestionsFetchRequested={this.onSuggestionsFetchRequested}
              onSuggestionsClearRequested={this.onSuggestionsClearRequested}
              getSuggestionValue={this.getSuggestionValue}
              renderSuggestion={this.renderSuggestion}
              inputProps={{
                classes,
                disabled: !category,
                id: "contact-categoryId",
                label: t("contact_categoryId"),
                placeholder: t("contact_pls_select"),
                value: categoryId,
                onChange: this.handleCategoryId
              }}
              theme={{
                container: classes.container,
                suggestionsContainerOpen: classes.suggestionsContainerOpen,
                suggestionsList: classes.suggestionsList,
                suggestion: classes.suggestion
              }}
              renderSuggestionsContainer={options => (
                <Paper {...options.containerProps} square>
                  {options.children}
                </Paper>
              )}
            />
          </Grid>
          {/* </Grid>  */}
        </FilterList>
        <Header
          session={t("sidebar_cms")}
          title={t("contact_list_contacts")}
          showFilterDate={true}
          handleFilterDate={this.handleFilterDate}
          from={from}
          to={to}
        />
        <TableFormat
          onRef={ref => (this.mTable = ref)}
          orderBy=""
          contentDialog={t("contact_do_you_want_to_delete_this_contact")}
          onDelete={this.handleDelete}
          title={t("contact_list_contacts")}
          showFilter={true}
          openFilter={e => this.showFilter(e)}
          listFilter={listFilter}
          showActionToolbar={false}
          placeholder={t("contact_search_by_customer_name_phone_email")}
          headCells={headCells}
          totalCount={total}
          count={count}
          size={"medium"}
          isCollapse={true}
          collapse={collapse}
          actionColumn={this.actionColumn}
          renderCollapse={this.renderCollapse}
          handleOpenCollapes={this.handleOpenCollapes}
          getList={this.getList}
          rows={list_contact.map((row, index) => {
            const parsePhone = _parsePhoneNumber(row.countryCode, row.phone);
            return {
              id: row._id,
              isCustomer: this.renderIsCustomer(row),
              name: row.name,
              email: row.email,
              phone: parsePhone.isValid
                ? parsePhone.format_internal
                : row.countryCode + "" + row.phone,
              ip: row.ip,
              createdAt: formatDatetime(row.createdAt),
              item: row
            };
          })}
        />
      </div>
    );
  }
}

Contacts.propTypes = {
  classes: PropTypes.object.isRequired,
  theme: PropTypes.object.isRequired
};
const mapState = state => ({
  list_contact: state.serviceContacts.list_contact,
  list_fromType: state.serviceContacts.list_fromType,
  list_categoryId: state.serviceContacts.list_categoryId,
  list_category: state.serviceContacts.list_category,
  total: state.serviceContacts.total,
  count: state.serviceContacts.count,
  permission: state.user.user.roleId
});

const mapDispatch = dispatch => ({
  getList: dispatch.serviceContacts.getList,
  isRead: dispatch.serviceContacts.isRead,
  getListCategory: dispatch.serviceContacts.getListCategory,
  getListCategoryId: dispatch.serviceContacts.getListCategoryId,
  getListFromType: dispatch.serviceContacts.getListFromType,
  delete: dispatch.serviceContacts.delete,
  createCustomer: dispatch.serviceContacts.createCustomer
});

export default connect(
  mapState,
  mapDispatch
)(translate("translations")(withStyles(styles, { withTheme: true })(Contacts)));
